import React from "react";
import { translateService } from "../../services/imports";

// The verification evidence a face-verified signing tool keeps at each
// signing (the gateway's SignerVerificationEvidence: Identomat's files, kept
// with the signing's other evidence, their storage billed; a file switched on
// that does not come fails the signing). The session PDF stays off and
// disabled while Identomat's PDF export fails (gateway, 2026-10-20): the
// website always sends pdf false, which also switches it off on a tool that
// had it on.

const t = (k, ...a) => translateService.t(`signers.evidence.${k}`, ...a);
export const EVIDENCE = ["image", "video", "pdf"];
const DISABLED = ["pdf"];

// a face-verified tool keeps evidence; the others do not use the options
export const keepsEvidence = (authTypes) => (authTypes || []).includes("FACE");

export const defaultEvidence = () => ({ image: true, video: true, pdf: false });

// what goes to the gateway: every member, the disabled ones off
export const evidenceBody = (value) => ({ image: !!value.image, video: !!value.video, pdf: false });

// at least one kept (the gateway refuses all off)
export const evidenceValid = (value) => !!(value && (value.image || value.video));

// the labels of what is kept, e.g. "face image, liveness video"
export const keptLabels = (value) => EVIDENCE.filter((k) => value && value[k]).map((k) => t(k));

// props: value {image, video, pdf}, onChange(value), error, idPrefix
export default function EvidenceFields({ value, onChange, error, idPrefix = "signer-evidence" }) {
  return (
    <fieldset className="signer-dialog__group signer-evidence">
      <legend>{t("title")}</legend>
      {EVIDENCE.map((k) => {
        const off = DISABLED.includes(k);
        return (
          <label key={k} className={`signer-dialog__choice ${off ? "is-off" : ""}`} htmlFor={`${idPrefix}-${k}`}>
            <input
              id={`${idPrefix}-${k}`}
              type="checkbox"
              disabled={off}
              checked={!off && !!value[k]}
              onChange={(e) => onChange({ ...value, [k]: e.target.checked })}
            />
            <span>
              <strong>{t(k)}</strong>
              {off && <small>{t("pdfOff")}</small>}
            </span>
          </label>
        );
      })}
      <small className="signer-evidence__hint">{t("hint")}</small>
      {error && <em className="signer-dialog__error">{error}</em>}
    </fieldset>
  );
}
